import T, { GetLang } from "./Translations";
import TranslationButton from "@components/formInputs/buttons/TranslationButton";

import { useGlobalContext } from "@components/contextProvider/ContextProvider";

import "@/styles/TranslationButton.scss";

const TranslationButtonGroup = (): JSX.Element => {
    const { dispatch } = useGlobalContext();
    const lang = GetLang();

    return (
        <section className="translation-buttons-container-main">
            <div className="button-container">
                <TranslationButton
                    className="translation-button"
                    label="English"
                    onClick={() => {
                        dispatch({
                            type: "Lang",
                            lang: "en"
                        });
                    }}
                />
                <TranslationButton
                    className="translation-button"
                    label="Español"
                    onClick={() => {
                        dispatch({
                            type: "Lang",
                            lang: "es"
                        });
                    }}
                />
                <TranslationButton
                    className="translation-button"
                    label="普通話"
                    onClick={() => {
                        dispatch({
                            type: "Lang",
                            lang: "zh"
                        });
                    }}
                />
                <TranslationButton
                    className="translation-button"
                    label="Русский"
                    onClick={() => {
                        dispatch({
                            type: "Lang",
                            lang: "ru"
                        });
                    }}
                />
            </div>
            <div className="experimental-text">*{T({ tKey: "Breadcrumb_Translations", langStr: lang })}</div>
        </section>
    );
};

export default TranslationButtonGroup;
